import { createSelector } from 'reselect';

import { AppState } from '../../_store/rootReducer';
import { ChooseTypeState } from './reducer';

const selectNode = (state: AppState) => state.type;

export const examType = createSelector(selectNode, (state: ChooseTypeState) => state.examType);
